import { Component, OnInit, ViewChild } from "@angular/core";

import { AngularFireDatabase } from "@angular/fire/database";
import { AngularFirestore } from "@angular/fire/firestore";
import { UserManager } from "src/app/Services/UserManager/user-manager";
import { Subject } from "rxjs";
import { MatSort } from "@angular/material/sort";
import { takeUntil } from "rxjs/operators";
import { MatTableDataSource } from "@angular/material/table";

import _ from "lodash";
import { FormControl } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { ORGS, PROFILES } from "src/Constants";

type UrlChange = {
  pop: boolean;
  state: any;
  type: string;
  url: string;
};

@Component({
  selector: "app-admin-view",
  templateUrl: "./admin-view.component.html",
  styleUrls: ["./admin-view.component.css"],
})
export class AdminViewComponent implements OnInit {
  profile;
  leaving = new Subject();
  orgChange = new Subject();
  authLevel;
  orgs = [];
  orgsub;
  organization;
  invitationLink;
  isSuper = false;
  orgsList;
  displayedColumns = [
    "name",
    "entityId",
    "zips",
    "outreach",
    "pastor",
    "organizer",
    "address",
    "city",
  ];
  @ViewChild(MatSort) sort: MatSort;
  selectedTab = new FormControl(0);

  entityId;
  _tabs = [
    "Individual Orgs",
    "All Orgs",
    "Activity",
    "Applications",
    "All Contacts",
    "Languages",
  ];

  _urls = [
    "individual",
    "all",
    "activity",
    "applications",
    "contacts",
    "languages",
  ];
  constructor(
    private um: UserManager,
    private route: ActivatedRoute,
    private db: AngularFireDatabase,
    private afs: AngularFirestore,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.location.subscribe((change: UrlChange) => {
      // only called when browser back/forward button pressed
      // console.log(change, history)
      let items = change.url.split("/");

      let tab = items.pop();
      const index = this._urls.indexOf(tab);
      if (index !== this.selectedTab.value) {
        this.selectedTab.setValue(index);
        // console.log("updated index to ", index)
      } else {
        // console.log("Already updated")
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      const tab = this.route.snapshot.paramMap.get("tab");
      switch (tab) {
        case "individual":
          this.selectedTab.setValue(0);
          break;
        case "all":
          this.selectedTab.setValue(1);
          break;
        case "activity":
          this.selectedTab.setValue(2);
          break;
        case "applications":
          this.selectedTab.setValue(3);
          break;
        case "contacts":
          this.selectedTab.setValue(4);
          break;
        case "search":
          this.selectedTab.setValue(5);
          break;
        case "languages":
          this.selectedTab.setValue(6);
          break;
        default: {
          this.location.go("/admin/individual");
        }
      }

      this.um
        .getProfileSubject()
        .takeUntil(this.leaving)
        .subscribe((profile) => {
          if (!_.isEqual(profile, this.profile)) {
            this.profile = profile;
            !!profile && this.getAccessLevel();
          }
        });
    }, 0);
  }
  updateIndex = (index) => {
    // change url
    // console.log('set index to', index)
    let pathitems = this.location.path().split("/");
    pathitems[pathitems.length - 1] = this._urls[index];
    const path = pathitems.join("/");
    if (this.location.path() !== path) {
      this.location.go(path);
    }
    this.selectedTab.setValue(index);
  };

  orgnizationChange = ({ value: org }) => {
    this.setOrg(org);
  };
  setOrg = async (org) => {
    this.orgChange.next();
    this.organization = org;
    this.getPrivalegedSubscription();
  };

  getOrgs = async (superAdmin = false) => {
    this.orgs = []; // clear orgs first
    try {
      if (superAdmin) {
        this.isSuper = true;
        this.afs
          .collection(ORGS, (ref) => ref.orderBy("name", "asc"))
          .valueChanges()
          .takeUntil(this.leaving)
          .subscribe((orgs) => (this.orgs = orgs));
        this.orgsList = new MatTableDataSource(this.orgs);
        this.orgsList.sort = this.sort;
        this.getPrivalegedSubscription();
      }
    } catch (e) {}
  };

  addOrg = (org) => {
    this.orgs.push(org);
  };

  updateProfile = async (profile) => {
    this.profile = profile;
  };

  getAccessLevel = async () => {
    //break subscription everytime we get a new profile
    try {
      this.orgsub.unsubscribe();
    } catch (e) {
      // it shall throw when its null.
    }

    this.afs
      .collection<{ approved: boolean }>("Admins")
      .snapshotChanges()
      .take(1)
      .subscribe((admins) => {
        admins.forEach((adminRef) => {
          if (
            adminRef.payload.doc.id === this.profile.uid &&
            adminRef.payload.doc.data()?.approved === true
          ) {
            this.authLevel = "admin";
            this.getOrgs(true);
          }
        });
      });
  };

  getPrivalegedSubscription() {
    if (this.authLevel) {
      // console.log('getting org')
      const organization = this.organization?.id
        ? this.organization.id
        : this.profile.organization;
      this.afs
        .collection(ORGS)
        .doc(`${organization}`)
        .valueChanges()
        .takeUntil(this.leaving)
        .takeUntil(this.orgChange)
        .subscribe((o) => {
          this.organization = o;
          this.invitationLink = `www.itiswritten.study/register/${o["entityId"]}`;
        });
    }
  }
}
